import {ApiClient} from '@hconnect/apiclient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'
import {useEffect} from 'react'

import {EventsSummary} from '../types'

type Props = {
  plantId: string
  startDate?: string
  endDate?: string
}

type Options = Omit<UseQueryOptions<EventsSummary, AxiosError>, 'queryKey' | 'queryFn'> & {
  onError?: (error: AxiosError) => void
}

const QueryKey = 'shift-events-count-per-category'

export const useEventsSummary = ({plantId, startDate, endDate}: Props, options?: Options) => {
  const query = useQuery<EventsSummary, AxiosError>({
    queryKey: [QueryKey, plantId, startDate, endDate],
    queryFn: async ({signal}) => {
      const response = await ApiClient.axiosInstance.get<EventsSummary>(
        `/shifthandover/${plantId}/search/events/count-per-category`,
        {params: {startDate, endDate}, signal}
      )

      return response.data
    },
    ...options
  })

  const onError = options?.onError

  useEffect(() => {
    if (query.error) {
      onError?.(query.error)
    }
  }, [query.error, onError])

  return query
}
